import type { LoginInput } from '@kidshome/api-contract';

/**
 * Dev-only login prefill. When running the dev server (`import.meta.env.DEV`), the login form is
 * pre-populated from the `VITE_DEV_*` vars written by `pnpm --filter @kidshome/api seed:dev`, so you
 * can open `/login` and just click "Sign in". In a production build `import.meta.env.DEV` is `false`,
 * so the defaults are empty — these credentials never ship.
 */
export function loginDefaults(): LoginInput {
  const empty: LoginInput = { email: '', password: '' };
  // Only the dev server prefills — never in a production build, and never under test (so the
  // login-form tests still exercise the empty-field validation path).
  if (!import.meta.env.DEV || import.meta.env.MODE === 'test') {
    return empty;
  }
  const env = import.meta.env as unknown as Record<string, string | undefined>;
  return {
    email: env.VITE_DEV_EMAIL ?? '',
    password: env.VITE_DEV_PASSWORD ?? '',
  };
}
